<div class="spinner-overlay" *ngIf="chartDataService.isSaveChartLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">Saving chart...</div>
  </nz-spin>
</div>

<div class="chart-details-wrapper">
  <h3 nz-typography class="nfl-form-label">Chart Details</h3>
  <form nz-form [nzLayout]="'vertical'" [formGroup]="chartDetails!" class="form-grid">
    <div nz-row [nzGutter]="[16, 24]">
      <div nz-col class="gutter-row" [nzSpan]="24">
        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Name</nz-form-label>
          <nz-form-control [nzErrorTip]="nameErrorTemplate">
            <input
              nz-input
              formControlName="name"
              id="name"
              appTrimFormInput
              placeholder="Chart Name"
              [readonly]="isViewMode"
              [ngClass]="{ 'readonly-input': isViewMode }"
            />
          </nz-form-control>
        </nz-form-item>
        <ng-template #nameErrorTemplate let-control>
          <div *ngIf="control?.errors?.['required']">Name is required</div>
          <div *ngIf="control?.errors?.['maxlength']">
            Name cannot exceed
            {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
        </ng-template>

        <nz-form-item>
          <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Description</nz-form-label>
          <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
            <textarea
              nz-input
              id="description"
              placeholder="Chart Description"
              formControlName="description"
              [nzAutosize]="{ minRows: 2, maxRows: 5 }"
              appTrimFormInput
              [readonly]="isViewMode"
              [ngClass]="{ 'readonly-input': isViewMode }"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
        <ng-template #descriptionErrorTemplate let-control>
          <div *ngIf="control?.errors?.['required']">Description is required</div>
          <div *ngIf="control?.errors?.['maxlength']">
            Description cannot exceed
            {{ control?.errors?.['maxlength'].requiredLength }} characters.
          </div>
        </ng-template>
      </div>
    </div>

    <nz-divider></nz-divider>
    <h3 nz-typography class="nfl-form-label">Chart Builder</h3>
    <div>
      <nz-form-item>
        <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Chart Type </nz-form-label>
        <nz-form-control nzErrorTip="Chart Type selection is required">
          <div class="chart-card-list">
            <nz-card
              class="chart-type-card"
              *ngFor="let card of chartCards; index as i"
              [ngClass]="{ selected: chartTypeFormControl.value === card.type }"
              (click)="!isCardDisabled(card) && selectChartType(card.type)"
              [class.disabled-card]="isCardDisabled(card)"
              nz-tooltip
              [nzTooltipTitle]="card.disabled && card.tooltip ? card.tooltip : ''"
            >
              <div class="chart-type-card-title">
                <span nz-icon [nzType]="card.icon" nzTheme="outline" class="icon"></span>
                <h5 nz-typography>{{ card.title }}</h5>
              </div>
              <div class="chart-type-card-subtitle">{{ card.subtitle }}</div>
            </nz-card>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>

  <app-chart-config
    [selectedChart]="selectedChart"
    (backEvent)="back()"
    [chartDetailsForm]="chartDetails"
    (typeAvailability)="onTypeAvailability($event)"
    (chartCardsValidated)="onChartCardsValidated()"
  ></app-chart-config>
</div>
